import React from 'react'
import PropTypes from 'prop-types'

const FlexSection = ({ children, className, ...rest }) =>
  <section
    className={'pt1 pb4 flex flex-column items-center justify-center h-100'}
    {...rest}
  >
    {children}
  </section>

FlexSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
    .isRequired
}

export default FlexSection



// WEBPACK FOOTER //
// ./src/components/FlexSection/FlexSection.js